import { ChecklistMetricStatus } from '../../handoff-checklist-v2/handoff-checklist-v2.types';
import { VoiceAirMetricDefinition } from '../voice-air-metrics.types';
import {
  getSchedulingStaffsQueryOptions,
  getSchedulingResourcesQueryOptions,
  getSchedulingSchedulesQueryOptions,
} from '../voice-air-handoff.queries';
import { getParsedErrorMessage } from 'redux/axios';
import { WEAVE_APP_URL } from 'apis/sso/sso-url-config';

export const providerOperatoryAvailableMetric: VoiceAirMetricDefinition = {
  id: 'provider_operatory_available',
  name: 'Provider/Operatory Available',
  isRequired: true,
  criteria: [
    {
      description: 'Verify provider schedule is configured.',
      whereToFix: {
        label: 'Scheduling Settings',
        url: `${WEAVE_APP_URL}/home/dashboard#settings/schedule/manage-providers`,
      },
      evaluate: async (ctx) => {
        try {
          const resp = await ctx.queryClient.fetchQuery(
            getSchedulingStaffsQueryOptions(ctx.locationId, ctx.orgId)
          );

          if (resp?.staffs && resp.staffs.length >= 1) {
            return {
              status: ChecklistMetricStatus.PASSED,
              reason: 'scheduling_config_complete',
            };
          }

          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'scheduling_provider_missing',
            message: 'No provider is configured. At least one provider must exist.',
          };
        } catch (err) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'provider_schedule_fetch_failed',
            message:
              getParsedErrorMessage(err) || 'Failed to verify provider configuration.',
          };
        }
      },
    },
    {
      description: 'Verify operatory hours are configured and synced.',
      whereToFix: {
        label: 'Scheduling Settings',
        url: `${WEAVE_APP_URL}/home/dashboard#settings/schedule/availability`,
      },
      evaluate: async (ctx) => {
        try {
          const resp = await ctx.queryClient.fetchQuery(
            getSchedulingResourcesQueryOptions(ctx.locationId, ctx.orgId)
          );

          if (resp?.resources && resp.resources.length >= 1) {
            return {
              status: ChecklistMetricStatus.PASSED,
              reason: 'scheduling_config_complete',
            };
          }

          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'scheduling_operatory_missing',
            message: 'No operatory is configured. At least one operatory must exist.',
          };
        } catch (err) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'operatory_fetch_failed',
            message:
              getParsedErrorMessage(err) || 'Failed to verify operatory configuration.',
          };
        }
      },
    },
    {
      description: 'Verify availability rules are configured.',
      whereToFix: {
        label: 'Scheduling Settings',
        url: `${WEAVE_APP_URL}/home/dashboard#settings/schedule/availability`,
      },
      evaluate: async (ctx) => {
        try {
          const resp = await ctx.queryClient.fetchQuery(
            getSchedulingSchedulesQueryOptions(ctx.locationId, ctx.orgId)
          );

          if (resp?.schedules && resp.schedules.length >= 1) {
            return {
              status: ChecklistMetricStatus.PASSED,
              reason: 'scheduling_config_complete',
            };
          }

          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'scheduling_availability_rule_missing',
            message:
              'No availability rule is configured. At least one availability rule must be created.',
          };
        } catch (err) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'schedules_fetch_failed',
            message: getParsedErrorMessage(err) || 'Failed to verify availability rules.',
          };
        }
      },
    },
  ],
};
